<template>
  <div class="home">
    <Header />
    <div class="top">
      <div class="box">
        <div class="left">
          <img src="@/assets/images/index_title.png" alt="" />
          <p class="desc">连接，从这里开始</p>
          <div class="download" @click="goto('windows')">立即下载</div>
          <img src="@/assets/images/index_sy.png" alt="" />
        </div>
        <div class="right">
          <img src="@/assets/images/index_top.png" alt="" />
        </div>
      </div>
    </div>
    <div class="content">
      <div class="gifbox">
        <div class="info">
          <img src="@/assets/images/index_i_icon1.png" alt="" />
          <p class="desc">随时随地 远程控制桌面</p>
          <div>
            <img src="@/assets/images/index_i_check.png" alt="" />
            <span>远程办公</span>
          </div>
          <p class="text">
            随时从远程位置访问工作计算机，以便处理文件、访问应用程序、与团队进行协作，让工作
            更高效进行。
          </p>
          <div>
            <img src="@/assets/images/index_i_check.png" alt="" />
            <span>远程技术支持</span>
          </div>
          <p class="text">
            技术人员远程连接到用户计算机，以解决技术问题、提供培训或进行故障排除，让技术支持
            更快速解决。
          </p>
        </div>
        <div class="gif">
          <video autoplay loop muted>
            <source src="@/assets/video/win2win.mp4" />
          </video>
        </div>
      </div>
      <div class="gifbox">
        <div class="gif">
          <video autoplay loop muted>
            <source src="@/assets/video/transfar.mp4" />
          </video>
        </div>
        <div class="info">
          <img src="@/assets/images/index_i_icon2.png" alt="" />
          <p class="desc">快速方便 远程传输文件</p>
          <div>
            <img src="@/assets/images/index_i_check.png" alt="" />
            <span>剪贴板添加</span>
          </div>
          <p class="text">支持复制粘贴添加文件</p>
          <div>
            <img src="@/assets/images/index_i_check.png" alt="" />
            <span>远程文件功能</span>
          </div>
          <p class="text">使用文件管理器高速传送，更适用于大文件</p>
        </div>
      </div>
      <div class="gifbox">
        <div class="info">
          <img src="@/assets/images/index_i_icon3.png" alt="" />
          <p class="desc">灵活高效 跨平台多端支持</p>
          <div>
            <img src="@/assets/images/index_i_check.png" alt="" />
            <span>多端支持</span>
          </div>
          <p class="text">打破设备限制，支持PC远控PC，Android远控PC</p>
        </div>
        <div class="gif">
          <video autoplay loop muted>
            <source src="@/assets/video/phone2win.mp4" />
          </video>
        </div>
      </div>
      <div class="infobox">
        <div>
          <img src="@/assets/images/index_i_lock.png" alt="" />
          <p>安全保障</p>
          <span>端对端通信加密</span>
        </div>
        <div>
          <img src="@/assets/images/index_i_good.png" alt="" />
          <p>稳定流畅</p>
          <span>多节点高速服务器部署</span>
        </div>
        <div>
          <img src="@/assets/images/index_i_4k.png" alt="" />
          <p>高清视觉</p>
          <span>最高支持4K分辨率/144帧率</span>
        </div>
      </div>
    </div>
    <div class="bottom">
      <div class="box">
        <div class="da" @click="goto('andriod')"></div>
        <div class="dw" @click="goto('windows')"></div>
      </div>
    </div>
    <Footer />
  </div>
</template>

<script>
import Header from "@/components/header.vue";
import Footer from "@/components/footer.vue";
export default {
  name: "home",
  components: {
    Header,
    Footer,
  },
  data() {
    return {};
  },
  methods: {
    goto(type) {
      this.$router.push({
        path: "/index/download",
        query: {
          type,
        },
      });
    },
  },
};
</script>

<style scoped lang="scss">
.top {
  width: 100%;
  height: 1000px;
  background: url(~@/assets/images/index_banner.png);
  background-size: center;
  .box {
    width: 1200px;
    padding-top: 230px;
    margin: 0 auto;
    position: relative;
    .left {
      width: 538px;
      img {
        margin-top: 20px;
      }
      .desc {
        height: 129px;
        line-height: 100px;
        font-size: 28px;
        font-weight: 400;
        color: #171f1d;
      }
      .download {
        width: 265px;
        height: 108px;
        margin-bottom: 36px;
        cursor: pointer;
        background: #3370ff;
        border-radius: 8px;
        text-align: center;
        line-height: 108px;
        font-size: 38px;
        font-weight: 400;
        color: #ffffff;
        &:hover {
          background: #4e83fc;
        }
      }
    }
    .right {
      position: absolute;
      top: 230px;
      left: 538px;
      img {
        width: 972px;
        height: 592px;
      }
    }
  }
}
.content {
  width: 1200px;
  margin: 0 auto;
  .gifbox {
    width: 100%;
    height: 530px;
    margin-top: 100px;
    div {
      &:first-child {
        float: left;
      }
      &:last-child {
        float: right;
      }
    }
    .gif {
      width: 788px;
      height: 530px;
      video {
        width: 788px;
        height: 530px;
      }
    }
    .info {
      width: 350px;
      height: 530px;
      display: flex;
      flex-direction: column;
      justify-content: center;
      > img {
        width: 80px;
        height: 80px;
      }
      .desc {
        height: 60px;
        font-size: 22px;
        font-weight: bold;
        color: #171f1d;
      }
      div {
        > img {
          width: 17px;
          height: 17px;
        }
        span {
          padding-left: 16px;
          font-size: 18px;
          font-weight: bold;
          color: #171f1d;
        }
      }
      .text {
        padding: 16px 0 24px 32px;
        font-size: 16px;
        font-weight: 400;
        color: #171f1d;
      }
    }
  }
  .infobox {
    width: 100%;
    height: 235px;
    margin: 120px 0;
    display: flex;
    justify-content: space-between;
    div {
      width: 334px;
      height: 235px;
      border-radius: 10px;
      background: linear-gradient(180deg, #e3f4fd 0%, #ffffff 100%);
      box-shadow: 0px 3px 6px 1px rgba(51, 112, 255, 0.2);
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      p {
        font-size: 24px;
        font-weight: bold;
        color: #171a1d;
      }
      span {
        font-size: 20px;
        font-weight: 400;
        color: #4a4a4a;
      }
    }
  }
}
.bottom {
  width: 100%;
  height: 292px;
  background: url(~@/assets/images/index_bottom.png);
  background-position: center center;
  overflow: hidden;
  .box {
    width: 442px;
    margin: 145px auto 0 auto;
    display: flex;
    justify-content: space-between;
    div {
      width: 191px;
      height: 82px;
      cursor: pointer;
      &:hover {
        background-position-x: -191px;
      }
      &:active {
        background-position-x: -382px;
      }
    }
    .da {
      background: url(~@/assets/images/index_i_da.png);
    }
    .dw {
      background: url(~@/assets/images/index_i_dw.png);
    }
  }
}
</style>
